import { render, staticRenderFns } from "./authView.vue?vue&type=template&id=5a9577fa&scoped=true&"
import script from "./authView.vue?vue&type=script&lang=js&"
export * from "./authView.vue?vue&type=script&lang=js&"
import style0 from "./authView.vue?vue&type=style&index=0&id=5a9577fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9577fa",
  null
  
)

export default component.exports